import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { BRAND } from "../lib/brand";
import { LogIn, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid email or password");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 py-12 bg-cream relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-yellow/30 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-[520px] h-[520px] rounded-full bg-brand-blue/10 blur-3xl" />

      <div className="relative w-full max-w-md card-soft bg-white p-8 sm:p-10">
        <Link to="/" className="flex items-center gap-3 mb-6" data-testid="admin-back-home">
          <img src={BRAND.logo} className="w-12 h-12" alt="logo" />
          <div>
            <div className="font-heading font-bold text-brand-blue">Innovative Preschool</div>
            <div className="text-xs text-[color:var(--text-secondary)]">Admin Console</div>
          </div>
        </Link>

        <h1 className="font-heading text-2xl font-bold mb-1">Welcome back</h1>
        <p className="text-sm text-[color:var(--text-secondary)] mb-6">Sign in to manage content</p>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="block text-sm font-semibold mb-1.5">Email</span>
            <input
              required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-cream border border-[#e6e2d8] rounded-2xl px-4 py-3 focus:outline-none focus:border-brand-blue focus:bg-white"
              placeholder="admin@innovativepreschool.com"
              data-testid="admin-email-input"
            />
          </label>
          <label className="block">
            <span className="block text-sm font-semibold mb-1.5">Password</span>
            <input
              required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-cream border border-[#e6e2d8] rounded-2xl px-4 py-3 focus:outline-none focus:border-brand-blue focus:bg-white"
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </label>

          {error && (
            <div className="bg-red-50 text-red-700 rounded-2xl px-4 py-3 text-sm flex items-center gap-2" data-testid="admin-login-error">
              <AlertCircle size={16} /> {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "Signing in..." : <>Sign in <LogIn size={16} /></>}
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
